"use strict";

var get = require('lodash.get');
var makeGetUserIdFromToken = function makeGetUserIdFromToken(_ref) {
  var getDecodedToken = _ref.getDecodedToken;
  return function () {
    return getDecodedToken().then(function (decoded) {
      var userId = get(decoded, 'sub');
      var normalizedUserId = userId ? userId.replace(/[.$\[\]#\/]/g, '') : null;
      return normalizedUserId;
    }).catch(function (error) {
      console.error(error);
      return null;
    });
  };
};
module.exports = {
  makeGetUserIdFromToken: makeGetUserIdFromToken
};